import React from 'react';

import styled from '@emotion/styled';

import { truncateTextByCharacters, getInitials } from '../../utils/utils';
import { ExternalLink } from '../Link/Link';

interface LicenseCardProps {
  license: string;
  degree: string;
  profession?: string;
  licensedAt: string;
  forApplicant?: boolean;
}

const LicenseCard: React.FC<LicenseCardProps> = ({
  degree,
  license,
  licensedAt,
  forApplicant,
}) => {
  return (
    <Container>
      <Box>
        <AbbreviationIcon>{getInitials(degree)}</AbbreviationIcon>
        <TextPart>
          <div className="name">
            {degree}, {truncateTextByCharacters(license, 10)}
          </div>
          <div className="title">
            {/* {truncateTextByCharacters(school || '', 40)}{' '} */}
          </div>
          <div className="title">Issue On {licensedAt}</div>
        </TextPart>
      </Box>
      {!forApplicant && (
        <Button href={license} target="_blank">
          View certificate
        </Button>
      )}
    </Container>
  );
};

export default LicenseCard;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px;
  gap: 2rem;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

const Box = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  gap: 8px;
  width: 100%;
`;

const TextPart = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.greyGrey2};

  & > * {
    word-break: break-all;
  }

  & > .name {
    color: ${({ theme }) => theme.palette.blackBlack3};
  }

  & > .title {
    font-size: 14px;
    display: flex;
  }
`;

const Button = styled(ExternalLink)`
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #2f80ed;

  @media (max-width: 480px) {
    padding-left: 52px;
  }
`;

const AbbreviationIcon = styled.div`
  display: grid;
  place-content: center;
  width: 50px;
  height: 50px;
  color: white;
  background-color: ${({ theme }) => theme.palette.mainBlue};
  font-size: 18px;
  font-weight: 400;
  border-radius: 50%;
`;
